/*
 * @Descripttion:
 * @Author: 黄佳鑫
 * @Date: 2025-11-24 15:01:20
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2025-12-04 17:37:50
 */
import { Button, Pagination, Spin, Tag, Empty } from 'antd'
import RadioTabs from '../../components/RadioTabs'
import Search from '../../components/SearchFilter'
import useToDoListHook from './hooks'
import styles from '@/modules/home/todolist/styles.module.scss'
import Buttonbar from '../../components/ButtonBar'
import emptyImage from '../../assets/img/empty.png'
import dayjs from 'dayjs'

const ToDoList = () => {
  const {
    hookstate,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    handleProcess,
  } = useToDoListHook()
  const {
    checkedRadioKey,
    currentRadioDict,
    dataSource,
    isTableLoading,
    pagination,
  } = hookstate

  const getUrgentTag = (status: string) => {
    if (status === '2') {
      return <Tag className={styles.urgentTag}>紧急</Tag>
    }
    return null
  }

  const getStatusTag = (status: string) => {
    switch (status) {
      case '1':
        return <Tag className={styles.statusTag}>待处理</Tag>
      case '2':
        return <Tag className={styles.urgentTag}>逾期</Tag>
      case '3':
        return <Tag className={styles.statusTag}>已完成</Tag>
      default:
        return null
    }
  }
  return (
    <div style={{ padding: '24px' }}>
      <Search
        fieldsData={[
          'title',
          'creatorName',
          'startCreatedTime',
          'endCreatedTime',
          'startDeadlineTime',
          'endDeadlineTime',
        ]}
        onSearch={handleSearchClick}
        keyName="TODOLIST"
        ScreenKey="TODOLIST"
      />
      <div style={{ padding: '10px 0 0' }}>
        <div style={{ marginBottom: 6 }}>
          <RadioTabs
            defaultKey={checkedRadioKey}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        <div className={styles.list}>
          <div className={styles.spinWrapper}>
            <Spin
              spinning={isTableLoading}
              style={{
                width: '100%',
                minHeight: 'calc(100vh - 400px)',
                display: 'block',
              }}
            >
              <div style={{ minHeight: 'calc(100vh - 400px)' }}>
                {dataSource.length > 0 ? (
                  <>
                    <div
                      className={styles.content}
                      style={{
                        height: 'calc(100vh - 400px)',
                        overflowY: 'auto',
                        paddingRight: 20,
                      }}
                    >
                      {dataSource.map((item) => (
                        <div key={item.id} className={styles.item}>
                          <div className={styles.itemLeft}>
                            <div
                              className={styles.taskName}
                              onClick={() => handleProcess(item)}
                            >
                              {item.title}
                            </div>
                            <div className={styles.itemMeta}>
                              <span>创建人{item.creatorName}</span>
                              <span className={styles.separator}>·</span>
                              <span>
                                截止日期:
                                {item.deadlineTime
                                  ? dayjs(item.deadlineTime).format(
                                      'YYYY-MM-DD',
                                    )
                                  : ''}
                              </span>
                              <span>
                                创建日期:
                                {item.createdTime
                                  ? dayjs(item.createdTime).format('YYYY-MM-DD')
                                  : ''}
                              </span>
                            </div>
                          </div>
                          <div className={styles.itemRight}>
                            {item.status !== '3' && getUrgentTag(item.priority)}
                            {getStatusTag(item.status)}
                            <Button
                              type="primary"
                              size="large"
                              className={styles.actionBtn}
                              onClick={() => handleProcess(item)}
                            >
                              处理
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className={styles.paginationWrapper}>
                      <Pagination
                        showTotal={(total) => `共 ${total} 条`}
                        showQuickJumper
                        pageSizeOptions={[
                          '10',
                          '20',
                          '30',
                          '50',
                          '100',
                          '200',
                          '500',
                        ]}
                        showSizeChanger
                        total={pagination.total}
                        current={pagination.current}
                        pageSize={pagination.pagesize}
                        onChange={handlePaginationChange}
                      />
                    </div>
                  </>
                ) : (
                  !isTableLoading && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 'calc(100vh - 400px)',
                        overflowY: 'auto',
                      }}
                    >
                      <Empty
                        image={emptyImage}
                        description="工作都完成了~非常棒哦"
                        imageStyle={{
                          width: '200px',
                          height: '200px',
                        }}
                      />
                    </div>
                  )
                )}
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ToDoList
/*
 * @Descripttion:
 * @Author: 黄佳鑫
 * @Date: 2025-11-24 15:01:20
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2025-12-04 17:37:50
 */
import { Button, Pagination, Spin, Tag, Empty } from 'antd'
import RadioTabs from '../../components/RadioTabs'
import Search from '../../components/SearchFilter'
import useToDoListHook from './hooks'
import styles from '@/modules/home/todolist/styles.module.scss'
import Buttonbar from '../../components/ButtonBar'
import emptyImage from '../../assets/img/empty.png'
import dayjs from 'dayjs'

const ToDoList = () => {
  const {
    hookstate,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    handleProcess,
  } = useToDoListHook()
  const {
    checkedRadioKey,
    currentRadioDict,
    dataSource,
    isTableLoading,
    pagination,
  } = hookstate

  const getUrgentTag = (status: string) => {
    if (status === '2') {
      return <Tag className={styles.urgentTag}>紧急</Tag>
    }
    return null
  }

  const getStatusTag = (status: string) => {
    switch (status) {
      case '1':
        return <Tag className={styles.statusTag}>待处理</Tag>
      case '2':
        return <Tag className={styles.urgentTag}>逾期</Tag>
      case '3':
        return <Tag className={styles.statusTag}>已完成</Tag>
      default:
        return null
    }
  }
  return (
    <div style={{ padding: '24px' }}>
      <Search
        fieldsData={[
          'title',
          'creatorName',
          'startCreatedTime',
          'endCreatedTime',
          'startDeadlineTime',
          'endDeadlineTime',
        ]}
        onSearch={handleSearchClick}
        keyName="TODOLIST"
        ScreenKey="TODOLIST"
      />
      <div style={{ padding: '10px 0 0' }}>
        <div style={{ marginBottom: 6 }}>
          <RadioTabs
            defaultKey={checkedRadioKey}
            radioItemDict={currentRadioDict}
            onChange={handleCheckedChange}
          ></RadioTabs>
        </div>
        <Buttonbar onRefresh={handleTableRefresh}></Buttonbar>
        <div className={styles.list}>
          <div className={styles.spinWrapper}>
            <Spin
              spinning={isTableLoading}
              style={{
                width: '100%',
                minHeight: 'calc(100vh - 400px)',
                display: 'block',
              }}
            >
              <div style={{ minHeight: 'calc(100vh - 400px)' }}>
                {dataSource.length > 0 ? (
                  <>
                    <div
                      className={styles.content}
                      style={{
                        height: 'calc(100vh - 400px)',
                        overflowY: 'auto',
                        paddingRight: 20,
                      }}
                    >
                      {dataSource.map((item) => (
                        <div key={item.id} className={styles.item}>
                          <div className={styles.itemLeft}>
                            <div
                              className={styles.taskName}
                              onClick={() => handleProcess(item)}
                            >
                              {item.title}
                            </div>
                            <div className={styles.itemMeta}>
                              <span>创建人{item.creatorName}</span>
                              <span className={styles.separator}>·</span>
                              <span>
                                截止日期:
                                {item.deadlineTime
                                  ? dayjs(item.deadlineTime).format(
                                      'YYYY-MM-DD',
                                    )
                                  : ''}
                              </span>
                              <span>
                                创建日期:
                                {item.createdTime
                                  ? dayjs(item.createdTime).format('YYYY-MM-DD')
                                  : ''}
                              </span>
                            </div>
                          </div>
                          <div className={styles.itemRight}>
                            {item.status !== '3' && getUrgentTag(item.priority)}
                            {getStatusTag(item.status)}
                            <Button
                              type="primary"
                              size="large"
                              className={styles.actionBtn}
                              onClick={() => handleProcess(item)}
                            >
                              处理
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className={styles.paginationWrapper}>
                      <Pagination
                        showTotal={(total) => `共 ${total} 条`}
                        showQuickJumper
                        pageSizeOptions={[
                          '10',
                          '20',
                          '30',
                          '50',
                          '100',
                          '200',
                          '500',
                        ]}
                        showSizeChanger
                        total={pagination.total}
                        current={pagination.current}
                        pageSize={pagination.pagesize}
                        onChange={handlePaginationChange}
                      />
                    </div>
                  </>
                ) : (
                  !isTableLoading && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 'calc(100vh - 400px)',
                        overflowY: 'auto',
                      }}
                    >
                      <Empty
                        image={emptyImage}
                        description="工作都完成了~非常棒哦"
                        imageStyle={{
                          width: '200px',
                          height: '200px',
                        }}
                      />
                    </div>
                  )
                )}
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ToDoList
